"use strict";

var LoggerInstance = require("js-logger").get("EmailSubscriptionApi");

var AbstractApi = require("./AbstractApi");

var EmailSubscriptionApi = class extends AbstractApi {
	submitEmailSubscriptionRequest(emailSubscriptionRequestData) {
		return this.post({
			data: emailSubscriptionRequestData,
			reCAPTCHA: true,
			url: "/api/emailsubscriptions"
		});
	}

	getEmailSubscriptions() {
		return this.get({
			url: "/api/myemailsubscriptions"
		});
	}

	subscribe(subscriptionType) {
		return this.post({
			data: { subscriptionTypes: [subscriptionType] },
			url: "/api/myemailsubscriptions"
		});
	}

	unsubscribe(subscriptionType) {
		return this.post({
			data: {
				isUnsubscribing: true,
				subscriptionTypes: [subscriptionType]
			},
			url: "/api/myemailsubscriptions"
		});
	}
};

module.exports = new EmailSubscriptionApi();
